export function initVehiclesPreview() {
	const ajaxObject = {
		url: WPURLS.ajaxurl,
		nonce: WPURLS.nonce
	}
	
	var blocks = document.querySelectorAll('.act-vehicles-preview');
	if ( blocks.length === 0 ) return;

	blocks.forEach( (block) => {
		let data = new FormData();
		data.append("action", "act_vehicles_preview");
	    data.append("nonce", ajaxObject.nonce);
	    data.append("expo_year", block.dataset.expoYear);
	    if ( block.dataset.exhibitors ) {
	    	data.append("exhibitors", block.dataset.exhibitors);
	    }

		fetch(ajaxObject.url, {
			method: "POST",
			credentials: "same-origin",
			body: data
		})
		.then(response => response.json())
		.then(result => {
			if ( result.success === true ) {
				block.innerHTML = result.data.html;
				block.classList.remove('default');
			}
		})
		.catch(error => {
			console.error("AJAX Error:", error);
		});
	});
}